import React from "react";

const ForkMe = () => (
  <a
    href="https://github.com/thefapinstructor/fapinstructor"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      style={{ position: "absolute", top: 0, right: 0, border: 0 }}
      src="https://s3.amazonaws.com/github/ribbons/forkme_right_red_aa0000.png"
      alt="Fork me on GitHub"
    />
  </a>
);

export default ForkMe;



// WEBPACK FOOTER //
// ./src/components/ForkMe.js